import React from 'react';
import { useEvent } from '../../contexts/EventContext';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  const {
    currentEvent
  } = useEvent();
  return <div className="w-full" data-id="element-4225">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1 font-gotham" data-id="element-4226">
          {label}
        </label>}
      <input className={`w-full px-4 py-2 border rounded-lg font-gotham focus:outline-none focus:ring-2 transition-all ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-opacity-50'} ${className}`} style={!error ? {
      '--tw-ring-color': currentEvent.colors.accent
    } as React.CSSProperties : {}} {...props} data-id="element-4227" />
      {error && <p className="mt-1 text-sm text-red-500 font-gotham" data-id="element-4228">{error}</p>}
    </div>;
}